import React, { FC } from 'react';
import { Button, Modal } from 'src/common';
import ConfirmContent from '../ConfirmContent';
import { IBidIdentifier } from '../../../models/bids/Bids/types';
import { useTranslation } from 'react-i18next';

interface IProps {
  onOk: () => void;
  onCancel: () => void;
  linkedBids: IBidIdentifier[];
  bids: IBidIdentifier[];
}
export const ConfirmModal: FC<IProps> = props => {
  const { onOk, linkedBids, bids, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal
      title={t('Common.warning')}
      visible
      maskClosable
      onCancel={onCancel}
      footer={
        <>
          <Button type={'text'} onClick={onCancel}>
            {t('Common.cancel')}
          </Button>
          <Button type={'primary'} onClick={onOk}>
            {t('Common.confirm')}
          </Button>
        </>
      }
    >
      {!!linkedBids.length && <p>{t('BidSpaces.assigningWarning')}</p>}
      {!!bids.length && <ConfirmContent title={t('BidSpaces.assigningBidWarning')} bids={bids} />}
    </Modal>
  );
};

export default ConfirmModal;
